import React, { useState, useEffect } from 'react';
import Select from 'react-select';

export function AutoSelect({ title = "", attr = [], id, val, action, feedback, kvFeedback, size = 3, v = "val", n = "name", inputFeedback, placeholder = "請選擇" }) {
    const [colSize] = useState("col-md-" + size)
    const [mSelectedOption, setSelectOption] = useState(null)
    const [options, setOptions] = useState([])

    useEffect(() => {
        if (attr.length > 0) {
            setOptions(attr)
            var os = []
            os.push({ value: "", label: "" })

            attr.map((item) => {
                var obj = { value: item[v], label: item[n] }
                if (item[v] === val) {
                    setSelectOption(obj)
                }
                os.push(obj)
            })
            setOptions(os)
            // console.log(attr)
        }
    }, [attr])

    useEffect(() => {
        if (val === undefined || val === "") {
            setSelectOption(null)
        }
    }, [val])

    const os = [
        { value: 'chocolate', label: 'aaaChocolate' },
        { value: 'strawberry', label: 'aaaStrawberry' },
        { value: 'vanilla', label: 'aaaVanilla' },
    ];

    const handleChange = selectedOption => {
        console.log("handleChange")
        setSelectOption(selectedOption)
        // console.log(selectedOption)
        if (selectedOption === null) {
            if (action)
                action("")
            if (feedback)
                feedback("")
            if (kvFeedback)
                kvFeedback(id, "")
        } else {
            if (action)
                action(selectedOption.value)
            if (feedback)
                feedback(selectedOption.label)
            if (kvFeedback)
                kvFeedback(id, selectedOption.value)
        }
    };

    const inputChange = input => {
        if (inputFeedback !== undefined) {
            inputFeedback(input)
        }
    }

    const indicatorSeparatorStyle = {
        alignSelf: 'stretch',
        marginBottom: 8,
        marginTop: 8,
        width: 1,
    };

    const IndicatorSeparator = ({ innerProps }) => {
        return <span style={indicatorSeparatorStyle} {...innerProps} />;
    };

    return (
        <>
            <div className={colSize}>
                {title === undefined || title === "" ? <></> : <p>{title}</p>}
                <Select
                    placeholder={placeholder}
                    components={{ IndicatorSeparator }}
                    value={mSelectedOption}
                    onChange={handleChange}
                    onInputChange={inputChange}
                    options={options}
                    isClearable
                    o
                />
            </div>
        </>
    );
}